import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

import { CenteredIndeterminateSpinnerComponent } from "./components/centered-indeterminate-spinner/centered-indeterminate-spinner.component";
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import { DigitalEquipmentFormComponent } from "./components/digital-equipment-form/digital-equipment-form.component";
import { SetPositionBtnComponent } from "./components/set-position-btn/set-position-btn.component";
import { StateChipComponent } from "./components/state-chip/state-chip.component";
import { DigitalRoadworkAtlasModule, DigitalRoadworkMaterialModule } from "./modules";

@NgModule({
	declarations: [
		CenteredIndeterminateSpinnerComponent,
		StateChipComponent,
		SetPositionBtnComponent,
		ConfirmDialogComponent,
		DigitalEquipmentFormComponent,
	],
	imports: [
		CommonModule,
		DigitalRoadworkAtlasModule,
		DigitalRoadworkMaterialModule,
		ReactiveFormsModule,
		FormsModule,
		TranslateModule.forChild({ isolate: false }),
	],
	exports: [
		CenteredIndeterminateSpinnerComponent,
		DigitalRoadworkAtlasModule,
		DigitalRoadworkMaterialModule,
		DigitalEquipmentFormComponent,
		StateChipComponent,
		SetPositionBtnComponent,
		TranslateModule,
	],
})
export class SharedModule {}
